module.exports = __webpack_public_path__ + "img/qyyxU7.431f5937.png";